import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO'
import isToday from 'date-fns/isToday'
import isTomorrow from 'date-fns/isTomorrow'
import { tr } from 'date-fns/locale'

const formatDate = (date, dateFormat = 'd MMMM yyyy', newOpts = {}) => {
	try {
		let opts = {
			parsed: false,
			checkRelative: false,
			...newOpts,
		}
		if (date) {
			if (!opts.parsed) {
				date = parseISO(date);
			}
			if(opts.checkRelative && isToday(date)) {
				return 'Bugün';
			}
			else if(opts.checkRelative && isTomorrow(date)) {
				return 'Yarın';
			}
			else {
				return format(date, dateFormat, { locale: tr, ...opts });
			}
		}
		else {
			return 'Hatalı Tarih';
		}
	}
	catch(e) {
		console.warn('Format Date Error:', e);
		return 'Hatalı Tarih';
	}
}

export default formatDate